export let getScrollTop = function(dom, offset){
	let $el = document.querySelector(dom);
	let t 	= Math.floor( $el.getBoundingClientRect().top + window.pageYOffset );
	let obj = {};
	obj.top 		= t;
	obj.offsetTop 	= t + offset;
	obj.height 		= $el.clientHeight;
	obj.id 			= $el.getAttribute("id") ? $el.getAttribute("id") : "";
	return obj;
}
export let deleteDomain = function( $dom ){
	//console.log($dom);
	const links = $dom.querySelectorAll('a[href]');
	links.forEach(a => {
		try {
			const url = new URL(a.href);
	
			// 同一ドメインだけ変換したい場合は以下の条件を入れる
			if (url.origin === window.location.origin || url.origin === "https://bootsmark.com" || url.origin === "https://regal-boots-mark.com" ) {
				a.href = url.pathname + url.search + url.hash; // 例: /about?x=1#top
			}
		} catch (e) {
				// URL() に失敗した場合 (相対パスなど) は無視
		}
	  });
	//console.log('delete')
}